<template>
  <div>
    <input :disabled="readOnly" v-model="value" type="checkbox" :id="setting.name" />
    <label :for="setting.name">{{ setting.displayName }}</label>
  </div>
</template>

<script>
import { SettingBool } from "../../code/classes/SettingBool";

export default {
  props: {
    readOnly: { type: Boolean, default: false },
    setting: { type: SettingBool },
  },
  computed: {
    value: {
      get() {
        return this.setting.value;
      },
      set(value) {
        this.setting.SetValue(value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
</style>
